module.exports = __webpack_public_path__ + "static/media/fundo-mapa.f021ca9c.jpg";